import { render } from "./fundbilllog.vue?vue&type=template&id=0a3b55b6"
import script from "./fundbilllog.vue?vue&type=script&lang=js"
export * from "./fundbilllog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__